import Backdrop from "../Backdrop/Backdrop";
import classes from "./Modal.module.scss";

const Modal = ({ children }) => {
  return (
    <Backdrop type="dark">
      <div className={classes.Modal}>{children}</div>
    </Backdrop>
  );
};

export default Modal;
